/**
 * @file add-new-vendor.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/add-new-vendor.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/add-new-vendor
 * @description Page component for adding new vendors in the vendors management section.
 *   Displays a form to input vendor details, upload vendor logo, and save the vendor information.
 *   Allows users to add new vendors with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import uploadImg from "../../../../_admin/assets/media/upload.png";
import EditSVG from "../../../../_admin/assets/media/svg_uTrade/edit-round.svg";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import APICallService from "../../../../api/apiCallService";
import { master, vendor } from "../../../../api/apiEndPoints";
import { fileValidation } from "../../../../Global/fileValidation";
import clsx from "clsx";
import FsLightbox from "fslightbox-react";
import moment from "moment";
import AutoComplete from "../../../custom/autoComplete";
import { Add, AllSeller, PermissionModule } from "../../../../utils/constants";
import Method from "../../../../utils/methods";
import { useAuth } from "../../auth";
import { CustomSelectWhite } from "../../../custom/Select/CustomSelectWhite";
import ExpiryLicence from "../../../modals/LicenseExpiry";
import { sellerJSON } from "../../../../api/apiJSON/seller";
import {
  BANKTYPES,
  CURRENCY,
  PAYMENTMODE,
  PAYMENTTERMS,
  TAXREGTYPES,
} from "../../../../utils/staticJSON";
import CustomDatePicker from "../../../custom/DateRange/CustomDatePicker";

const daysOfWeek = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

const AddNewVendor = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [vendorData, setVendorData] = useState<any>({
    name: "",
    ownerName: "",
    address: "",
    lat: "1",
    lng: "1",
    about: "",
    categories: [],
    image: "",
    imageReader: {},
    types: "",
    certificates: [],
    phone: "",
    email: "",
    phoneCountry: "+255",
    country: "Tanzania",
    city: "",
    state: "",
    pincode: "",
    taxRegType: "",
    taxId: "",
    currency: "TZS",
    paymentTerms: null,
    creditLimit: "",
    preferredPaymentMode: null,
    vendorCategory: [],
    deliveryDays: [],
    hasAnnualContract: false,
    contractValidFrom: "",
    contractValidTo: "",
    banks: [
      {
        tigoNumber: "",
        bankName: "",
        branchName: "",
        bankType: "",
        accountNumber: "",
        identifierCode: "",
      },
    ],
    tinNumber: "",
    vatNumber: "",
    leadDuration: "",
    workingDays: [],
    legalName: "",
    tradeName: "",
  });

  const [sellerValidation, setSellerValidation] = useState<any>({
    name: false,
    ownerName: false,
    address: false,
    city: false,
    state: false,
    country: false,
    pincode: false,
    about: false,
    categories: false,
    image: false,
    phone: false,
    businessTypes: false,
    email: false,
    legalName: false,
    tradeName: false,
    tinNumber: false,
    types: false,
    taxRegType: false,
    currency: false,
    paymentTerms: false,
    preferredPaymentMode: false,
    leadDuration: false,
    workingDays: false,
  });

  const [bankValidation, setBankValidation] = useState<any[]>([]);

  const [businessCertificates, setBusinessCertificate] = useState([]);
  const [filteredCertificates, setFilteredCertificate] = useState<any>([]);
  const [categories, setCategories] = useState([]);
  const [businessTypes, setBusinessTypes] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [image, setImage] = useState("");
  const [defaultIndex, setIndex] = useState<number>();
  const [currentIndex, setCurrentIndex] = useState<any>();
  const [showExpiry, setShowExpiry] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [requiredCertificates, setRequiredCertificates] = useState<any[]>([]);
  const [certificateDocs, setCertificateDocs] = useState<any>({});
  useEffect(() => {
    (async () => {
      if (!Method.hasPermission(PermissionModule.AllVendors, Add, currentUser)) {
        return window.history.back();
      }
      await fetchInitData();
    })();
  }, []);
  const handleBasicDetailsChange = (name: string, value: string | number) => {
    let temp: any = { ...vendorData };
    let tempValidation: any = { ...sellerValidation };
    temp[name] = typeof value === "string" ? value.trimStart() : value;
    tempValidation[name] = false;
    if (typeof value === "string" && !value.length) tempValidation[name] = true;
    setVendorData(temp);
    setSellerValidation(tempValidation);
  };

  const handleBankChange = (index: number, key: string, value: string) => {
    const temp: any = { ...vendorData };
    const banks = temp.banks ? [...temp.banks] : [];
    banks[index] = { ...banks[index], [key]: value };
    temp.banks = banks;
    setVendorData(temp);

    const bv = bankValidation ? [...bankValidation] : [];
    bv[index] = bv[index] ? { ...bv[index] } : {};
    const hasValue =
      value !== null && value !== undefined && String(value).trim() !== "";
    if (key === "bankType") {
      bv[index]["bankType"] = false;
      if (hasValue) {
        const tnum = temp.banks[index]?.tigoNumber;
        bv[index]["tigoNumber"] = !(tnum && String(tnum).trim() !== "");
      } else {
        bv[index]["tigoNumber"] = false;
      }
    } else if (key === "tigoNumber") {
      bv[index]["tigoNumber"] = !hasValue;
    } else if (key === "bankName") {
      bv[index]["bankName"] = !hasValue;
    } else if (key === "branchName") {
      bv[index]["branchName"] = !hasValue;
    } else if (key === "accountNumber") {
      bv[index]["accountNumber"] = !hasValue;
    }
    setBankValidation(bv);
  };

  const addBank = () => {
    const temp: any = { ...vendorData };
    temp.banks = temp.banks ? [...temp.banks] : [];
    temp.banks.push({
      tigoNumber: "",
      bankName: "",
      branchName: "",
      bankType: "",
      accountNumber: "",
      identifierCode: "",
    });
    setVendorData(temp);
  };

  const removeBank = (index: number) => {
    const temp: any = { ...vendorData };
    temp.banks = temp.banks
      ? temp.banks.filter((_: any, i: number) => i !== index)
      : [];
    setVendorData(temp);
  };
  const fetchInitData = async () => {
    setFetchLoading(true);
    const params: any = {
      categoriesDepth: 1,
    };
    let categoryApiService = new APICallService(
      master.categoryList,
      params,
      "",
      "",
      "",
      "",
      AllSeller
    );
    let categoryResponse = await categoryApiService.callAPI();
    if (categoryResponse) {
      setCategories(categoryResponse.records);
    }
    let businessApiService = new APICallService(
      master.listBusinessTypes,
      {
        "addedFor[0]": 1,
      },
      "",
      "",
      "",
      "",
      AllSeller
    );
    let businessResponse = await businessApiService.callAPI();
    if (businessResponse) {
      setBusinessTypes(businessResponse.records);
    }
    let certificateApiService = new APICallService(
      master.listCertificate,
      "",
      "",
      "",
      "",
      "",
      AllSeller
    );
    let certificateResponse = await certificateApiService.callAPI();
    if (certificateResponse) {
      let businessTemp: any = [];
      certificateResponse.records.map((certVal: any) => {
        let catTemp: any = [];
        if (certVal.categories.length) {
          certVal.categories.map((catVal: any) => {
            catTemp.push(catVal._id);
          });
        }
        businessTemp.push({ ...certVal, categories: catTemp });
      });
      setBusinessCertificate(businessTemp);
    }
    setFetchLoading(false);
  };
  const handleCategorySelect = (event: any) => {
    let temp: any = { ...vendorData };
    let tempValidation: any = { ...sellerValidation };
    if (event.length) {
      event.map((eventVal: any) => {
        if (!temp.categories.includes(eventVal._id)) {
          temp.categories.push(eventVal._id);
        }
      });
      tempValidation.categories = false;
    } else {
      temp.categories = [];
      tempValidation.categories = true;
    }
    if (temp.categories.length) {
      let businessCertificatesTemp = [...businessCertificates];
      let businessTemp: any = [];
      businessCertificatesTemp.map((certVal: any, index: number) => {
        if (certVal.categories.length) {
          temp.categories.map((catVal: any) => {
            if (certVal.categories.includes(catVal)) {
              if (businessTemp.length) {
                if (
                  !businessTemp.some(
                    (tempVal: any) => tempVal._id === certVal._id
                  )
                ) {
                  businessTemp.push(certVal);
                  temp.certificates.push({
                    image: "",
                    imageReader: "",
                    reference: "",
                    expiry: "",
                    expiryRequire: false,
                    expiryCalendar: new Date(),
                  });
                }
              } else {
                businessTemp.push(certVal);
                temp.certificates.push({
                  image: "",
                  imageReader: "",
                  reference: "",
                  expiry: "",
                  expiryRequire: false,
                  expiryCalendar: new Date(),
                });
              }
            }
          });
        } else {
          businessTemp.push(certVal);
          temp.certificates.push({
            image: "",
            imageReader: "",
            reference: "",
            expiry: "",
            expiryRequire: false,
            expiryCalendar: new Date(),
          });
        }
        if (businessTemp.length) {
          setFilteredCertificate(businessTemp);
        }
      });
    } else {
      setFilteredCertificate([]);
      temp.certificates = [];
    }
    setSellerValidation(tempValidation);
    setVendorData(temp);
  };
  const handleBusinessTypesSelect = (id: string) => {
    let temp: any = { ...vendorData };
    let tempValidation: any = { ...sellerValidation };
    temp.types = id;
    tempValidation.businessTypes = false;
    setVendorData(temp);
    setSellerValidation(tempValidation);
  };
  const handleBusinessCertificate = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
    id: string,
    expiryRequire: boolean
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!fileValidation(file)) return;

    const previewUrl = URL.createObjectURL(file);

    setVendorData((prev: any) => {
      const updatedCertificates = [...prev.certificates];

      updatedCertificates[index] = {
        ...updatedCertificates[index],
        image: previewUrl,
        imageReader: file,
        reference: id,
        expiryRequire,
        isPrefill: false,
      };

      return {
        ...prev,
        certificates: updatedCertificates,
      };
    });

    if (expiryRequire) {
      setCurrentIndex(index);
      setShowExpiry(true);
    }
  };

  const handleShowExpiry = (index: number) => {
    setCurrentIndex(index);
    setShowExpiry(true);
  };
  const handleExpirySelect = (value: string, index: number) => {
    let data: any = { ...vendorData };
    data.certificates[currentIndex].expiry = moment(value).format("YYYY-MM-DD");
    data.certificates[currentIndex].expiryCalendar = value;
    setVendorData(data);
    setShowExpiry(false);
  };
  const handleImageChange = (event: any) => {
    const selectedFiles = event.target.files;
    let temp = { ...vendorData };
    if (!selectedFiles) return;
    else {
      if (fileValidation(selectedFiles?.[0])) {
        temp.image = URL.createObjectURL(selectedFiles?.[0]);
        temp.imageReader = selectedFiles?.[0];
      }
    }
    setVendorData(temp);
  };

  const handleAddVendor = async () => {
    let temp = { ...vendorData };
    let validateTemp = {
      name: false,
      ownerName: false,
      address: false,
      city: false,
      state: false,
      country: false,
      pincode: false,
      categories: false,
      image: false,
      phone: false,
      businessTypes: false,
      email: false,
      legalName: false,
      tradeName: false,
      tinNumber: false,
      types: false,
      taxRegType: false,
      currency: false,
      paymentTerms: false,
      preferredPaymentMode: false,
      leadDuration: false,
      workingDays: false,
    };

    if (temp.name === "") {
      validateTemp.name = true;
    }
    if (temp.ownerName === "") {
      validateTemp.ownerName = true;
    }
    if (temp.phone === "") {
      validateTemp.phone = true;
    }
    if (temp.email === "") {
      validateTemp.email = true;
    }
    if (temp.address === "") {
      validateTemp.address = true;
    }
    if (temp.city === "") {
      validateTemp.city = true;
    }
    if (temp.state === "") {
      validateTemp.state = true;
    }
    if (temp.country === "") {
      validateTemp.country = true;
    }
    if (temp.pincode === "") {
      validateTemp.pincode = true;
    }
    if (temp.tinNumber === "") {
      validateTemp.tinNumber = true;
    }
    if (temp.types === "") {
      validateTemp.types = true;
    }
    if (temp.categories.length === 0) {
      validateTemp.categories = true;
    }
    if (temp.taxRegType === "") {
      validateTemp.taxRegType = true;
    }
    if (temp.currency === "") {
      validateTemp.currency = true;
    }
    if (temp.paymentTerms === null || temp.paymentTerms === "") {
      validateTemp.paymentTerms = true;
    }
    if (
      temp.preferredPaymentMode === null ||
      temp.preferredPaymentMode === ""
    ) {
      validateTemp.preferredPaymentMode = true;
    }
    if (temp.legalName === "") {
      validateTemp.legalName = true;
    }
    if (temp.tradeName === "") {
      validateTemp.tradeName = true;
    }
    if (temp.leadDuration === "") {
      validateTemp.leadDuration = true;
    }
    if (!temp.workingDays || temp.workingDays.length === 0) {
      validateTemp.workingDays = true;
    }

    let bankErrors: any[] = [];
    let isBankInvalid = false;

    if (temp.banks && temp.banks.length > 0) {
      temp.banks.forEach((bank: any) => {
        const errors = {
          bankName: !bank.bankName || String(bank.bankName).trim() === "",
          branchName: !bank.branchName || String(bank.branchName).trim() === "",
          accountNumber:
            !bank.accountNumber || String(bank.accountNumber).trim() === "",
          bankType: false,
          tigoNumber: bank.bankType
            ? !bank.tigoNumber || String(bank.tigoNumber).trim() === ""
            : false,
        };

        if (
          errors.bankName ||
          errors.branchName ||
          errors.accountNumber ||
          errors.tigoNumber
        ) {
          isBankInvalid = true;
        }

        bankErrors.push(errors);
      });
    }

    setBankValidation(bankErrors);

    if (
      Object.values(validateTemp).every((val) => val === false) &&
      !isBankInvalid
    ) {
      setLoading(true);

      const payload = {
        imageReader: temp.imageReader,
        removeImage: temp.removeImage || false,
        ownerName: temp.ownerName,
        name: temp.name,
        phone: temp.phone,
        phoneCountry: temp.phoneCountry,
        email: temp.email,
        lat: temp.lat,
        lng: temp.lng,
        about: temp.about,
        legalName: temp.legalName,
        tradeName: temp.tradeName,
        tinNumber: temp.tinNumber,
        vatNumber: temp.vatNumber,
        categories: temp.categories,
        paymentTerms: temp.paymentTerms,
        paymentMode: temp.preferredPaymentMode,
        creditLimit: temp.creditLimit,
        leadDuration: temp.leadDuration,
        currency: temp.currency,
        hasAnnualContract: temp.hasAnnualContract,
        contractValidFrom: temp.contractValidFrom,
        contractValidTo: temp.contractValidTo,
        workingDays:
          temp.workingDays && temp.workingDays.length ? temp.workingDays : [],
        taxDetails: {
          type: temp.taxRegType,
          number: temp.tinNumber,
        },
        addressDetails: {
          addressLine1: temp.address,
          city: temp.city,
          state: temp.state,
          countryName: temp.country,
          postalCode: temp.pincode,
        },
        certificates: temp.certificates,
        types: temp.types,
        banks: temp.banks?.filter(
          (bank: any) =>
            bank.bankName ||
            bank.branchName ||
            bank.bankType ||
            bank.accountNumber ||
            bank.tigoNumber
        ),
      };

      let apiService = new APICallService(
        vendor.addVendor,
        sellerJSON.addVendorProfile(payload),
        "",
        "",
        "",
        "",
        AllSeller
      );

      let response = await apiService.callAPI();

      if (response) {
        navigate("/UProcure/vendors/list-vendors");
      }
      setLoading(false);
    }
    setSellerValidation(validateTemp);
  };

  const handleAddressChange = async (
    value: string,
    lat: string,
    lng: string
  ) => {
    let tempValidation: any = { ...sellerValidation };
    let temp: any = { ...vendorData };
    temp["address"] = value.trimStart();
    temp["lat"] = lat;
    temp["lng"] = lng;
    tempValidation["address"] = false;
    if (!value.length) tempValidation["address"] = true;
    setVendorData(temp);
    setSellerValidation(tempValidation);
  };
  const handleClick = (index: number, image: string) => {
    setToggler(!toggler);
    setImage(image);
    setIndex(index);
  };
  const handleHideExpiry = () => {
    setShowExpiry(false);
  };

  const handleVendorCategoryChange = (selected: any[]) => {
    let temp: any = { ...vendorData };
    let tempValidation: any = { ...sellerValidation };
    const selectedValues = Array.isArray(selected) ? selected : [];

    temp.categories = selectedValues
      .map((val: any) => val?.value || val?._id)
      .filter(Boolean);
    tempValidation.categories = !temp.categories.length;

    const selectedCategoryIds: string[] = [];
    selectedValues.forEach((val: any) => {
      if (val?._id) {
        selectedCategoryIds.push(val._id);
      }
      if (val?.uTradeCategoryId) {
        selectedCategoryIds.push(val.uTradeCategoryId);
      }

      const matchedCategory: any = (categories as any[]).find(
        (catVal: any) => catVal?._id === val?._id
      );
      if (matchedCategory?._id) {
        selectedCategoryIds.push(matchedCategory._id);
      }
      if (matchedCategory?.uTradeCategoryId) {
        selectedCategoryIds.push(matchedCategory.uTradeCategoryId);
      }
    });

    const uniqueCategoryIds = Array.from(new Set(selectedCategoryIds));

    if (temp.categories.length) {
      const matchedCertificates = businessCertificates.filter((cert: any) => {
        if (!cert.categories?.length) return true;
        return cert.categories.some((catId: string) =>
          uniqueCategoryIds.includes(catId)
        );
      });

      const uniqueCertificates = Array.from(
        new Map(
          matchedCertificates.map((cert: any) => [cert._id, cert])
        ).values()
      );

      setFilteredCertificate(uniqueCertificates);

      const existingByRef = new Map<string, any>(
        (temp.certificates || [])
          .filter((cert: any) => cert?.reference)
          .map((cert: any) => [cert.reference, cert] as [string, any])
      );

      temp.certificates = uniqueCertificates.map((cert: any) => {
        const existing = existingByRef.get(cert._id);
        if (existing) {
          return {
            ...existing,
            reference: cert._id,
            expiryRequire: cert.expiryRequire,
          };
        }

        return {
          image: "",
          imageReader: "",
          reference: cert._id,
          expiry: "",
          expiryRequire: cert.expiryRequire,
          expiryCalendar: new Date(),
        };
      });
    } else {
      setFilteredCertificate([]);
      temp.certificates = [];
    }

    setSellerValidation(tempValidation);
    setVendorData(temp);
  };

  const handleWorkingDayChange = (dayValue: number) => {
    const temp = { ...vendorData };
    const currentDays = [...temp.workingDays];

    if (currentDays.includes(dayValue)) {
      temp.workingDays = currentDays.filter((d: number) => d !== dayValue);
    } else {
      temp.workingDays = [...currentDays, dayValue].sort((a, b) => a - b);
    }

    setVendorData(temp);
    setSellerValidation((prev: any) => ({
      ...prev,
      workingDays: !temp.workingDays || temp.workingDays.length === 0,
    }));
  };

  const formatWorkingDays = (days: number[]) => {
    if (!days || days.length === 0) return "";

    const sortedDays = [...days].sort((a, b) => a - b);
    const groups: number[][] = [];
    let currentGroup: number[] = [sortedDays[0]];

    for (let i = 1; i < sortedDays.length; i++) {
      if (sortedDays[i] === sortedDays[i - 1] + 1) {
        currentGroup.push(sortedDays[i]);
      } else {
        groups.push(currentGroup);
        currentGroup = [sortedDays[i]];
      }
    }
    groups.push(currentGroup);

    return groups
      .map((group) => {
        if (group.length === 1) {
          return daysOfWeek.find((d) => d.value === group[0])?.label;
        } else {
          const firstDay = daysOfWeek.find((d) => d.value === group[0])?.label;
          const lastDay = daysOfWeek.find(
            (d) => d.value === group[group.length - 1]
          )?.label;
          return `${firstDay}-${lastDay}`;
        }
      })
      .join(", ");
  };

  return (
    <div className="p-5">
      <Row className="mb-6">
        <Col xs={12}>
          <h1 className="fs-22 fw-bolder">Add new Supplier</h1>
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mb-8">
          <Card className="bg-light pt-2 mb-6 mb-xl-9 border">
            <Card.Header className="border-bottom-0">
              <Card.Title>
                <h5 className="fs-22 fw-bolder">Supplier Details</h5>
              </Card.Title>
            </Card.Header>
            <Card.Body className="pt-0 pb-5">
              <Row>
                <Col md={4} className="mb-3">
                  <h5 className="fs-16 fw-600 mb-4">Business logo</h5>
                  {vendorData.image ? (
                    <div className="border border-r10px bg-white p-1 text-center">
                      <div className="image-input image-input-outline min-w-xl-260px min-h-xl-150px">
                        <div
                          className="image-input-wrapper shadow-none bgi-contain w-100 h-100 bgi-position-center"
                          style={{ backgroundRepeat: `no-repeat` }}
                        >
                          {vendorData.image && (
                            <img
                              width={262}
                              height={149}
                              src={vendorData.image}
                              className="img-fluid mh-150px border-r10px object-fit-contain"
                              alt=""
                            />
                          )}
                        </div>
                        <label
                          className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px "
                          data-kt-image-input-action="change"
                          title=""
                        >
                          <img src={EditSVG} alt="" height={33} width={33} />
                          <input
                            type="file"
                            name="avatar"
                            accept=".png, .jpg, .jpeg"
                            onChange={(event) => {
                              handleImageChange(event);
                            }}
                          />
                          <input type="hidden" name="avatar_remove" />
                        </label>
                      </div>
                      <div className="mt-2 text-gray text-italic">{`Image dimensions:-(700x700px)`}</div>
                    </div>
                  ) : (
                    <div className="text-justify">
                      <div className="upload-btn-wrapper">
                        <div className="symbol symbol-md-235px">
                          <img
                            src={uploadImg}
                            className="img-fluid min-h-200px min-w-200px"
                            alt=""
                          />
                        </div>
                        <input
                          className="w-100 h-100"
                          type="file"
                          name="myfile"
                          onChange={(event) => {
                            handleImageChange(event);
                          }}
                        />
                      </div>
                      <div className="mt-2 text-gray text-italic">{`Image dimensions:-(700x700px)`}</div>
                    </div>
                  )}
                </Col>
                <Col md={8}>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Supplier Name
                      </Form.Label>
                      <Form.Control
                        className={clsx(
                          "form-control-custom bg-white",
                          sellerValidation.ownerName ? "border-danger" : ""
                        )}
                        type="text"
                        placeholder="Type here…"
                        value={vendorData.ownerName}
                        onChange={(e: any) =>
                          handleBasicDetailsChange("ownerName", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Contact Person
                      </Form.Label>
                      <Form.Control
                        className={clsx(
                          "form-control-custom bg-white",
                          sellerValidation.name ? "border-danger" : ""
                        )}
                        type="text"
                        placeholder="Type here…"
                        value={vendorData.name}
                        onChange={(e: any) =>
                          handleBasicDetailsChange("name", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Phone number
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text
                          className={clsx(
                            "bg-white border-right-0 fs-16 fw-600 text-black px-6",
                            sellerValidation.phone ? "border-danger" : ""
                          )}
                        >
                          +255
                        </InputGroup.Text>
                        <Form.Control
                          className={clsx(
                            "form-control-custom border-active-none bg-white border-left-0 ps-0",
                            sellerValidation.phone ? "border-danger" : ""
                          )}
                          value={vendorData.phone}
                          onChange={(e: any) =>
                            handleBasicDetailsChange("phone", e.target.value)
                          }
                        />
                      </InputGroup>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Email
                      </Form.Label>
                      <Form.Control
                        className={clsx(
                          "form-control-custom bg-white",
                          sellerValidation.email ? "border-danger" : ""
                        )}
                        type="text"
                        placeholder="Type here…"
                        value={vendorData.email}
                        onChange={(e: any) =>
                          handleBasicDetailsChange("email", e.target.value)
                        }
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Vendor Type
                      </Form.Label>
                      <CustomSelectWhite
                        onChange={(val: any) =>
                          handleBasicDetailsChange("types", val?.value || "")
                        }
                        border={sellerValidation.types ? "#ff0000" : ""}
                        options={
                          businessTypes.length
                            ? businessTypes.map((c: any) => ({
                                value: c._id,
                                label: c.title,
                                _id: c._id,
                                title: c.title,
                              }))
                            : []
                        }
                        isMulti={false}
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500">
                        VAT number
                      </Form.Label>
                      <Form.Control
                        className="form-control-custom bg-white"
                        type="text"
                        placeholder="Type here…"
                        value={vendorData.vatNumber}
                        onChange={(e: any) =>
                          handleBasicDetailsChange("vatNumber", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {/* Business Details */}
          <Card className="bg-light pt-2 mb-6 mb-xl-9 border">
            <Card.Header className="border-bottom-0">
              <Card.Title>
                <h5 className="fs-22 fw-bolder">Business Details</h5>
              </Card.Title>
            </Card.Header>
            <Card.Body className="pt-0 pb-5">
              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Legal Name
                  </Form.Label>
                  <Form.Control
                    value={vendorData.legalName}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("legalName", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.legalName ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Trade Name
                  </Form.Label>
                  <Form.Control
                    value={vendorData.tradeName}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("tradeName", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.tradeName ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Business address
                  </Form.Label>
                  <AutoComplete
                    address={vendorData.address}
                    handleAddressChange={handleAddressChange}
                    lat={vendorData.lat}
                    lng={vendorData.lng}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">City</Form.Label>
                  <Form.Control
                    value={vendorData.city}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("city", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.city ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    State / Region
                  </Form.Label>
                  <Form.Control
                    value={vendorData.state}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("state", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.state ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    PIN / ZIP Code
                  </Form.Label>
                  <Form.Control
                    value={vendorData.pincode}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("pincode", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.pincode ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Country
                  </Form.Label>
                  <Form.Control
                    value={vendorData.country}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("country", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.country ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Tax Registration Type
                  </Form.Label>
                  <CustomSelectWhite
                    onChange={(val: any) =>
                      handleBasicDetailsChange("taxRegType", val?.value || "")
                    }
                    border={sellerValidation.taxRegType ? "#ff0000" : ""}
                    options={TAXREGTYPES}
                    isMulti={false}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Tax ID Number
                  </Form.Label>
                  <Form.Control
                    value={vendorData.tinNumber}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("tinNumber", e.target.value)
                    }
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.tinNumber ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Currency
                  </Form.Label>
                  <CustomSelectWhite
                    onChange={(val: any) =>
                      handleBasicDetailsChange("currency", val?.value || "")
                    }
                    value={{
                      value: vendorData.currency,
                      label: CURRENCY.find(
                        (c) => c.value === vendorData.currency
                      )?.label,
                    }}
                    border={sellerValidation.currency ? "#ff0000" : ""}
                    options={CURRENCY}
                    isDisabled={true}
                    isMulti={false}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Payment Terms
                  </Form.Label>
                  <CustomSelectWhite
                    onChange={(val: any) =>
                      handleBasicDetailsChange("paymentTerms", val?.value || "")
                    }
                    border={sellerValidation.paymentTerms ? "#ff0000" : ""}
                    options={PAYMENTTERMS}
                    isMulti={false}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500">Credit Limit</Form.Label>
                  <Form.Control
                    type="number"
                    min={0}
                    step="1"
                    value={vendorData.creditLimit}
                    onChange={(e: any) => {
                      const value = e.target.value;
                      if (value === "" || Number(value) >= 0) {
                        handleBasicDetailsChange("creditLimit", value);
                      }
                    }}
                    className="form-control-custom bg-white"
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Preferred Payment Mode
                  </Form.Label>
                  <CustomSelectWhite
                    onChange={(val: any) =>
                      handleBasicDetailsChange(
                        "preferredPaymentMode",
                        val?.value || ""
                      )
                    }
                    border={
                      sellerValidation.preferredPaymentMode ? "#ff0000" : ""
                    }
                    options={PAYMENTMODE}
                    isMulti={false}
                  />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Lead Duration
                  </Form.Label>
                  <Form.Control
                    type="number"
                    min={1}
                    step="1"
                    value={vendorData.leadDuration}
                    onChange={(e: any) => {
                      const value = e.target?.value;
                      if (value === "" || Number(value) >= 1) {
                        handleBasicDetailsChange("leadDuration", value);
                      }
                    }}
                    className={clsx(
                      "form-control-custom bg-white",
                      sellerValidation.leadDuration ? "border-danger" : ""
                    )}
                    placeholder="Type here…"
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Working Days
                  </Form.Label>
                  {Array.isArray(vendorData.workingDays) &&
                    vendorData.workingDays.length > 0 && (
                      <span className="ms-3 p-2 bg-white border border-secondary border-r10px">
                        <span className="fs-14 fw-600 text-muted">
                          Selected:{" "}
                        </span>
                        <span className="fs-16 fw-600 text-dark">
                          {formatWorkingDays(vendorData.workingDays)}
                        </span>
                      </span>
                    )}
                  <div
                    className={`border border-r10px bg-white p-4 ${
                      sellerValidation.workingDays ? "border-danger" : ""
                    }`}
                  >
                    <Row>
                      {daysOfWeek.map((day) => (
                        <Col xs={6} md={3} key={day.value} className="mb-3">
                          <Form.Check
                            type="checkbox"
                            id={`day-${day.value}`}
                            label={day.label}
                            checked={vendorData.workingDays.includes(day.value)}
                            onChange={() => handleWorkingDayChange(day.value)}
                            className="fs-16 fw-500"
                          />
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label className="fs-16 fw-500">
                    Annual Contract
                  </Form.Label>
                  <Row className="align-items-center mb-3">
                    <Col xs="auto">
                      <div className="form-check form-check-custom form-check-solid">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="annualContractNo"
                          checked={!vendorData.hasAnnualContract}
                          onChange={() => {
                            setVendorData({
                              ...vendorData,
                              hasAnnualContract: false,
                              contractValidFrom: "",
                              contractValidTo: "",
                            });
                          }}
                        />
                        <label
                          className="form-check-label fs-16 fw-600 text-dark"
                          htmlFor="annualContractNo"
                        >
                          No
                        </label>
                      </div>
                    </Col>
                    <Col xs="auto">
                      <div className="form-check form-check-custom form-check-solid">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="annualContractYes"
                          checked={vendorData.hasAnnualContract}
                          onChange={() => {
                            setVendorData({
                              ...vendorData,
                              hasAnnualContract: true,
                            });
                          }}
                        />
                        <label
                          className="form-check-label fs-16 fw-600 text-dark"
                          htmlFor="annualContractYes"
                        >
                          Yes
                        </label>
                      </div>
                    </Col>
                  </Row>
                  {vendorData.hasAnnualContract && (
                    <div className="mt-3 min-w-280px max-w-280px">
                      <Form.Label className="fs-14 fw-500 mb-2">
                        Contract Date Range
                      </Form.Label>
                      <CustomDatePicker
                        selectsRange={true}
                        startDate={
                          vendorData.contractValidFrom
                            ? new Date(vendorData.contractValidFrom)
                            : null
                        }
                        endDate={
                          vendorData.contractValidTo
                            ? new Date(vendorData.contractValidTo)
                            : null
                        }
                        onChange={(dates: any) => {
                          const [start, end] = dates;
                          setVendorData({
                            ...vendorData,
                            contractValidFrom: start
                              ? Method.convertDateToFormat(start, "YYYY-MM-DD")
                              : "",
                            contractValidTo: end
                              ? Method.convertDateToFormat(end, "YYYY-MM-DD")
                              : "",
                          });
                        }}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="Select contract dates"
                        inputTextBG="bg-white"
                      />
                    </div>
                  )}
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label className="fs-16 fw-500 required">
                    Supplier Category
                  </Form.Label>
                  <CustomSelectWhite
                    onChange={handleVendorCategoryChange}
                    loading={fetchLoading}
                    isDisabled={fetchLoading}
                    options={
                      categories.length
                        ? categories.map((c: any) => ({
                            value: c._id,
                            label: c.title,
                            _id: c._id,
                            title: c.title,
                            uTradeCategoryId: c.uTradeCategoryId,
                          }))
                        : []
                    }
                    border={sellerValidation.categories ? "#ff0000" : ""}
                    isMulti={true}
                    value={categories
                      .map((c: any) => ({
                        value: c._id,
                        label: c.title,
                        _id: c._id,
                        title: c.title,
                        uTradeCategoryId: c.uTradeCategoryId,
                      }))
                      .filter((opt: any) =>
                        vendorData.categories.includes(opt._id)
                      )}
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Label className="fs-16 fw-500">
                    About the business
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={vendorData.about}
                    onChange={(e: any) =>
                      handleBasicDetailsChange("about", e.target.value)
                    }
                    className="form-control-custom bg-white"
                    placeholder="Type here…"
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          {/* Bank Details */}
          <Card className="bg-light pt-2 mb-6 mb-xl-9 border">
            <Card.Header className="border-bottom-0">
              <Card.Title>
                <h5 className="fs-22 fw-bolder">Bank Details</h5>
              </Card.Title>
            </Card.Header>
            <Card.Body className="pt-0 pb-5">
              {vendorData.banks &&
                vendorData.banks.map((bank: any, idx: number) => (
                  <Row key={idx} className="mb-3">
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Bank Name
                      </Form.Label>
                      <Form.Control
                        value={bank.bankName}
                        onChange={(e: any) =>
                          handleBankChange(idx, "bankName", e.target.value)
                        }
                        className={clsx(
                          "form-control-custom bg-white",
                          bankValidation[idx]?.bankName ? "border-danger" : ""
                        )}
                        placeholder="Type here…"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Branch
                      </Form.Label>
                      <Form.Control
                        value={bank.branchName}
                        onChange={(e: any) =>
                          handleBankChange(idx, "branchName", e.target.value)
                        }
                        className={clsx(
                          "form-control-custom bg-white",
                          bankValidation[idx]?.branchName ? "border-danger" : ""
                        )}
                        placeholder="Type here…"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500 required">
                        Account Number
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={bank.accountNumber}
                        onChange={(e: any) =>
                          handleBankChange(idx, "accountNumber", e.target.value)
                        }
                        className={clsx(
                          "form-control-custom bg-white",
                          bankValidation[idx]?.accountNumber
                            ? "border-danger"
                            : ""
                        )}
                        placeholder="Type here…"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500">
                        Identifier Code
                      </Form.Label>
                      <Form.Control
                        value={bank.identifierCode}
                        onChange={(e: any) =>
                          handleBankChange(
                            idx,
                            "identifierCode",
                            e.target.value
                          )
                        }
                        className="form-control-custom bg-white"
                        placeholder="Type here…"
                      />
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Label className="fs-16 fw-500">
                        Mobile wallet
                      </Form.Label>
                      <CustomSelectWhite
                        onChange={(val: any) =>
                          handleBankChange(idx, "bankType", val?.value || "")
                        }
                        border={bankValidation[idx]?.bankType ? "#ff0000" : ""}
                        options={BANKTYPES}
                        isMulti={false}
                        isClearable={true}
                        value={
                          BANKTYPES.find(
                            (item) => item.value == bank?.bankType
                          ) || null
                        }
                      />
                    </Col>
                    {bank?.bankType ? (
                      <Col md={6} className="mb-3">
                        <Form.Label className="fs-16 fw-500 required">
                          {`${
                            BANKTYPES.find(
                              (item) => item.value == bank?.bankType
                            )?.title || ""
                          } Number`}
                        </Form.Label>
                        <Form.Control
                          value={bank.tigoNumber}
                          onChange={(e: any) =>
                            handleBankChange(idx, "tigoNumber", e.target.value)
                          }
                          className={clsx(
                            "form-control-custom bg-white",
                            bankValidation[idx]?.tigoNumber
                              ? "border-danger"
                              : ""
                          )}
                          placeholder="Type here…"
                        />
                      </Col>
                    ) : (
                      <></>
                    )}
                    <Col xs={12} className="d-flex align-items-end mb-3">
                      {idx > 0 && (
                        <Button className="uw-btn uw-btn-danger"
                          variant="danger"
                          onClick={() => removeBank(idx)}
                        >
                          Remove
                        </Button>
                      )}
                    </Col>
                  </Row>
                ))}
              <div className="d-flex">
                <Button className="uw-btn uw-btn-primary" variant="primary" onClick={addBank}>
                  Add bank account
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <FsLightbox
        toggler={toggler}
        disableLocalStorage={true}
        sources={[image]}
        // onClose={() => {
        //   handleClose()
        // }}
        exitFullscreenOnClose={true}
      />
      {filteredCertificates.length > 0 ? (
        <Card className="bg-light pt-2 mb-6 mb-xl-9 border">
          <Card.Header className="border-bottom-0">
            <Card.Title>
              <h5 className="fs-22 fw-bolder">Business certificates</h5>
            </Card.Title>
          </Card.Header>
          <Card.Body className="pt-0 pb-5">
            <Row className="align-items-center">
              {filteredCertificates.map(
                (filterVal: any, filterIndex: number) => {
                  return (
                    <>
                      <Col xl={4} sm={6} className="mb-5">
                        <h6 className="fs-16 fw-500 mb-3">{filterVal.title}</h6>
                        {vendorData.certificates[filterIndex]?.image ? (
                          <>
                            <div className="image-input image-input-outline symbol symbol-md-190px border border-r10px bg-white">
                              <div
                                className="image-input-wrapper shadow-none bgi-contain w-100 h-100 bgi-position-center"
                                // style={{
                                //     backgroundImage: `url(${imagePreviewUrl})`,
                                //     backgroundRepeat: `no-repeat`,
                                // }}
                              >
                                {vendorData.certificates[filterIndex]
                                  ?.image && (
                                  <img
                                    width={190}
                                    height={190}
                                    src={
                                      vendorData.certificates[filterIndex]
                                        ?.image
                                    }
                                    className="img-fluid mh-190px border-r10px object-fit-contain"
                                    alt=""
                                  />
                                )}
                              </div>
                              <label
                                className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px "
                                data-kt-image-input-action="change"
                                title=""
                              >
                                <img
                                  src={EditSVG}
                                  alt=""
                                  height={33}
                                  width={33}
                                />
                                <input
                                  type="file"
                                  name="avatar"
                                  accept=".png, .jpg, .jpeg"
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ): void =>
                                    handleBusinessCertificate(
                                      e,
                                      filterIndex,
                                      filterVal._id,
                                      filterVal.expiryRequire
                                    )
                                  }
                                />
                                <input type="hidden" name="avatar_remove" />
                              </label>
                            </div>
                            <h6 className="fs-16 fw-500 mb-3">
                              <Button
                                variant=""
                                className="btn-flush text-primary fw-600"
                                onClick={() => {
                                  handleClick(filterIndex, filterVal.image);
                                }}
                              >
                                View sample
                              </Button>
                            </h6>
                            {vendorData.certificates[filterIndex].expiry ? (
                              <div className="fs-16 fw-500 mt-3 d-inline-flex justify-content-center align-items-center">
                                Expires on{" "}
                                {moment(
                                  vendorData.certificates[filterIndex].expiry
                                ).format("DD MMM, YYYY")}{" "}
                                <label
                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px ms-2"
                                  data-kt-image-input-action="change"
                                  title=""
                                >
                                  <img
                                    src={EditSVG}
                                    alt=""
                                    height={24}
                                    width={24}
                                    onClick={() => {
                                      handleShowExpiry(filterIndex);
                                    }}
                                  />
                                </label>
                              </div>
                            ) : (
                              <></>
                            )}
                            <ExpiryLicence
                              showExpiry={showExpiry}
                              handleHideExpiry={handleHideExpiry}
                              handleExpirySelect={(value: string) => {
                                handleExpirySelect(value, filterIndex);
                              }}
                              value={new Date()}
                            />
                          </>
                        ) : (
                          <>
                            <div className="upload-btn-wrapper">
                              <div className="symbol symbol-md-190px">
                                <img
                                  height={190}
                                  width={190}
                                  src={uploadImg}
                                  className="img-fluid min-w-190px min-h-190px"
                                  alt=""
                                />
                              </div>
                              <input
                                className="w-100"
                                type="file"
                                name="myfile"
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ): void =>
                                  handleBusinessCertificate(
                                    e,
                                    filterIndex,
                                    filterVal._id,
                                    filterVal.expiryRequire
                                  )
                                }
                              />
                            </div>
                            <h6 className="fs-16 fw-500 mb-3">
                              <Button
                                variant=""
                                className="btn-flush text-primary fw-600"
                                onClick={() => {
                                  handleClick(filterIndex, filterVal.image);
                                }}
                              >
                                View sample
                              </Button>
                            </h6>
                          </>
                        )}
                      </Col>
                    </>
                  );
                }
              )}
            </Row>
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
      <div className="d-flex justify-content-end">
        {/* <Link to="seller-products"> */}
        <Button className="uw-btn uw-btn-primary uw-btn-lg"
          size="lg"
          onClick={() => {
            handleAddVendor();
          }}
          disabled={loading}
        >
          {!loading && (
            <span className="indicator-label fs-16 fw-bold">Add vendor</span>
          )}
          {loading && (
            <span
              className="indicator-progress fs-16 fw-bold"
              style={{ display: "block" }}
            >
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </Button>
        {/* </Link> */}
      </div>
    </div>
  );
};
export default AddNewVendor;
